import Vue from 'vue';

import Product from '../components/product.js';
import ProductRelated from '../components/product-related.vue';
import ProductCompleteLook from '../components/product-complete-look.vue';
import ProductRecent from '../components/product-recent.vue';

new Vue({
    el: '#template-product',

    delimiters: ['${', '}'],

    components: {
        Product,
        ProductRelated,
        ProductCompleteLook,
        ProductRecent
    }
});